module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-recognition.bfa6e8f8.png";